<ng-container *ngIf="footerTemplate">
    <app-partners></app-partners>
    <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
</ng-container>
<!---------------------------------------
           FOOTER
----------------------------------------->
<!------------- TYPE 1: DEFAULT ----------------->
<ng-template #footerDefault>
    <footer class="footer">
        <ng-container *ngTemplateOutlet="footerNavDefault"></ng-container>
        <ng-container *ngTemplateOutlet="footerContactDefault"></ng-container>
        <ng-container *ngTemplateOutlet="footerBackTop"></ng-container>
        <ng-container *ngTemplateOutlet="footerCopyright"></ng-container>
    </footer>
</ng-template>

<!------------- TYPE 2: CENTERED ----------------->
<ng-template #footerCentered>
    <footer class="footer footer-centered">
        <ng-container *ngTemplateOutlet="footerNavInlineHorizontal"></ng-container>
        <ng-container *ngTemplateOutlet="footerContactCentered"></ng-container>
        <ng-container *ngTemplateOutlet="footerBackTop"></ng-container>
        <ng-container *ngTemplateOutlet="footerCopyright"></ng-container>
    </footer>
</ng-template>

<!------------- TYPE 3: TWO COLUMNS ----------------->
<ng-template #footerTwoColumns>
    <footer class="footer footer-and-about footer-right">
        <div class="container">
            <div class="row justify-content-lg-between w-100">
                <div class="col-lg-4">
                    <ng-container *ngTemplateOutlet="footerAbout"></ng-container>
                </div>
                <div class="col-lg-7">
                    <ng-container *ngTemplateOutlet="footerNavInlineHorizontal"></ng-container>
                    <ng-container *ngTemplateOutlet="footerContactRight"></ng-container>
                </div>
            </div>
        </div>
        <ng-container *ngTemplateOutlet="footerBackTop"></ng-container>
        <ng-container *ngTemplateOutlet="footerCopyright"></ng-container>
    </footer>
</ng-template>

<!------------- TYPE 4: THREE COLUMNS ----------------->
<ng-template #footerThreeColumns>
    <footer class="footer footer-three-columns">
        <div class="container">
            <div class="row justify-content-lg-between w-100 mb-lg-5">
                <div class="col-lg-3 mb-4 mb-lg-0">
                    <ng-container *ngTemplateOutlet="footerNavInlineVertical"></ng-container>
                </div>
                <div class="col-lg-4">
                    <ng-container *ngTemplateOutlet="footerAbout"></ng-container>
                </div>
                <div class="col-auto">
                    <ng-container *ngTemplateOutlet="footerContactRight"></ng-container>
                </div>
            </div>
        </div>
        <ng-container *ngTemplateOutlet="footerBackTop"></ng-container>
        <ng-container *ngTemplateOutlet="footerCopyright"></ng-container>
    </footer>
</ng-template>

<!---------------------------------------
           FOOTER NAVIGATION
----------------------------------------->
<!------------- DEFAULT ----------------->
<ng-template #footerNavDefault>
    <div class="footer-nav footer-nav-default">
        <nav>
            <div class="row align-items-center justify-content-md-center w-100">
                <div class="col-md-6">
                    <ng-container *ngFor="let item of menu | slice : 0 : 5">
                        <a [routerLink]="['/' + item.item?.routerLink]" (click)="backToTop()"
                            *ngIf="!item.item?.routerLink.includes('https'); else externalLink">{{ item.title }}</a>

                        <ng-template #externalLink>
                            <a [href]="item.item?.routerLink" target="_blank" rel="noopener noreferrer">{{
                                item.title
                                }}</a>
                        </ng-template>
                    </ng-container>
                </div>
                <div class="col-auto col-xl-6">
                    <ng-container *ngFor="let item of menu | slice : 5 : menu?.length">
                        <a [routerLink]="['/' + item.item?.routerLink]" (click)="backToTop()"
                            *ngIf="!item.item?.routerLink.includes('https'); else externalLink">{{ item.title }}</a>
                        <ng-template #externalLink>
                            <a [href]="item.item?.routerLink" target="_blank" rel="noopener noreferrer">{{
                                item.title
                                }}</a>
                        </ng-template>
                    </ng-container>
                </div>
            </div>
        </nav>
    </div>
</ng-template>

<!---------- INLINE HORIZONTAL----------->
<ng-template #footerNavInlineHorizontal>
    <div class="footer-nav-inline footer-nav-inline-h mb-4">
        <ng-container *ngTemplateOutlet="footerNavElements"></ng-container>
    </div>
</ng-template>

<!---------- INLINE VERTICAL ----------->
<ng-template #footerNavInlineVertical>
    <div class="footer-nav-inline footer-nav-inline-v">
        <ng-container *ngTemplateOutlet="footerNavElements"></ng-container>
    </div>
</ng-template>

<!---------- ELEMENTS FOR REUSE PURPOSE ----------->
<ng-template #footerNavElements>
    <nav>
        <ng-container *ngFor="let item of menu | async">
            <ng-template [ngIf]="item.item?.routerType === '1'" [ngIfElse]="externalLink">
                <a class="footer-nav-link" [routerLink]="['/' + item.item.routerLink]" (click)="backToTop()">{{
                    item.title
                    }}</a>
            </ng-template>
            <ng-template #externalLink>
                <a class="footer-nav-link" [href]="item.item?.routerLink" target="_blank" rel="noopener noreferrer">{{
                    item.title
                    }}</a>
            </ng-template>
        </ng-container>
    </nav>
</ng-template>
<!---------------------------------------
           FOOTER CONTACT
----------------------------------------->

<!------------- DEFAULT ----------------->
<ng-template #footerContactDefault>
    <div class="footer-contact">
        <div class="container">
            <div class="row align-items-start">
                <div class="col-auto mb-4 mb-xl-0 ml-md-3 ml-xl-auto">
                    <div class="footer-signup">
                        <h3>{{ "MENU.REGISTER" | translate }}</h3>
                        <a [routerLink]="['/auth/register']" class="footer-signup-link">
                            <img [src]="getRegisterImage()" />
                            <fa-icon [icon]="icons.link"></fa-icon>
                        </a>

                        <p>{{ "FOOTER.SLOGAN" | translate }}</p>
                    </div>
                </div>
                <div class="col-auto ml-md-3">
                    <ng-container *ngTemplateOutlet="contactBlockDefault"></ng-container>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<!------------- CENTERED ----------------->
<ng-template #footerContactCentered>
    <ng-container *ngTemplateOutlet="contactBlockCentered"></ng-container>
</ng-template>

<!------------- RIGHT ----------------->
<ng-template #footerContactRight>
    <ng-container *ngTemplateOutlet="contactBlockRight"></ng-container>
</ng-template>

<!---------------------------------------
           CONTACT BLOCK
----------------------------------------->

<!---------- DEFAULT ----------->
<ng-template #contactBlockDefault>
    <div class="contact-block contact-block-default">
        <h3>{{ "MENU.CONTACT" | translate }}</h3>
        <ng-container *ngTemplateOutlet="contactBlockLines"></ng-container>
    </div>
</ng-template>
<!---------- CENTERED ----------->
<ng-template #contactBlockCentered>
    <div class="contact-block contact-block-centered mb-5">
        <h3>{{ "MENU.CONTACT" | translate }}</h3>
        <div class="d-flex flex-column justify-content-end">
            <span class="font-sm" *ngFor="let phone of setupService.contact?.phones">
                <span *ngIf="phone.type != 2">
                    <fa-icon *ngIf="phone.type != 2" [icon]="icons.phone"></fa-icon>
                    {{ phone.number }}</span>
                <a class="text-success link-underline-opacity-0" target="_blank" *ngIf="phone.type == 2"
                    href="https://wa.me/{{ this.clearPhoneNumber(phone?.number) }}">
                    <fa-icon class="link-success" *ngIf="phone.type == 2" [icon]="icons.whatsapp"></fa-icon>
                    {{ phone.number }}</a>
            </span>
        </div>
        <div class="mb-2">
            <fa-icon [icon]="icons.flag"></fa-icon>

            <span class="ml-2">{{ setupService.contact?.street }}, {{ setupService.contact?.number }},
                {{ setupService.contact?.neighborhood }} <br />
                CEP: {{ setupService.contact?.zipcode }} <br />
                {{ setupService.contact?.city }} - {{ setupService.contact?.state }}</span>
        </div>

        <span class="contact-block-social">
            <a [href]="social.item.routerLink" target="_blank" rel="noopener noreferrer"
                *ngFor="let social of registers">
                <fa-icon [icon]="icons[social.item.iconeLink]"></fa-icon>
            </a>
        </span>
    </div>
</ng-template>
<!---------- RIGHT ----------->
<ng-template #contactBlockRight>
    <div class="contact-block contact-block-right mb-5">
        <h3>{{ "MENU.CONTACT" | translate }}</h3>
        <div class="d-flex flex-column justify-content-end">
            <span class="font-sm" *ngFor="let phone of setupService.contact?.phones">
                <span *ngIf="phone.type != 2">
                    <fa-icon *ngIf="phone.type != 2" [icon]="icons.phone"></fa-icon>
                    {{ phone.number }}</span>
                <a class="text-success link-underline-opacity-0" target="_blank" *ngIf="phone.type == 2"
                    href="https://wa.me/{{ this.clearPhoneNumber(phone?.number) }}">
                    <fa-icon class="link-success" *ngIf="phone.type == 2" [icon]="icons.whatsapp"></fa-icon>
                    {{ phone.number }}</a>
            </span>
        </div>

        <div class="mb-2">
            <fa-icon [icon]="icons.flag"></fa-icon>
            <span class="ml-2">{{ setupService.contact?.street }}, {{ setupService.contact?.number }},
                {{ setupService.contact?.neighborhood }}
                CEP: {{ setupService.contact?.zipcode }} <br />
                {{ setupService.contact?.city }} - {{ setupService.contact?.state }}</span>
        </div>

        <span class="contact-block-social">
            <a [href]="social.item.routerLink" target="_blank" rel="noopener noreferrer"
                *ngFor="let social of registers">
                <fa-icon [icon]="icons[social.item.iconeLink]"></fa-icon>
            </a>
        </span>
    </div>
</ng-template>

<!---------------------------------------
           CONTACT BLOCK LINES
----------------------------------------->
<ng-template #contactBlockLines>
    <span class="footer-contact-line">
        <fa-icon [icon]="icons.flag"></fa-icon>
        <span>{{ setupService.contact?.street }}, {{ setupService.contact?.number }} -
            {{ setupService.contact?.neighborhood }} <br />
            CEP: {{ setupService.contact?.zipcode }} <br />
            {{ setupService.contact?.city }} -
            {{ setupService.contact?.state }}
        </span>
    </span>

    <div class="d-flex flex-column justify-content-end">
        <span class="footer-contact-line font-sm" *ngFor="let phone of setupService.contact?.phones">
            <span *ngIf="phone.type != 2">
                <fa-icon *ngIf="phone.type != 2" [icon]="icons.phone"></fa-icon>
                {{ phone.number }}</span>
            <a class="text-success link-underline-opacity-0" target="_blank" *ngIf="phone.type == 2"
                href="https://wa.me/{{ this.clearPhoneNumber(phone?.number) }}">
                <fa-icon class="link-success" *ngIf="phone.type == 2" [icon]="icons.whatsapp"></fa-icon>
                {{ phone.number }}</a>
        </span>
        <div *ngIf="hasOfficeHours()" class="d-flex flex-column justify-content-end align-items-end mb-1">
            <span class="footer-contact-line font-sm align-self-start">
                <fa-icon [icon]="icons.clock"></fa-icon>
                <span>{{ "FOOTER.OFFICE-HOURS" | translate }}</span>
            </span>
            <div class="footer-contact-line--hours w-100 d-flex justify-content-around font-sm"
                *ngFor="let time of setupService.contact?.officeHours | keyvalue : orderDays">
                <span class="ml-4">{{ time.key | ngxCapitalize }}:</span>
                <span> {{ time.value }}</span>
            </div>
        </div>
    </div>
    <span class="footer-contact-social">
        <a [href]="social.item.routerLink" target="_blank" rel="noopener noreferrer" *ngFor="let social of registers">
            <fa-icon [icon]="icons[social.item.iconeLink]" *ngIf="icons[social.item.iconeLink]"></fa-icon>
        </a>
    </span>
</ng-template>

<!-- FOOTER-ABOUT -->
<ng-template #footerAbout>
    <div class="footer-about">
        <h3>{{ "GENERAL.ABOUT" | translate }}</h3>
        <p>
            {{
            setupService.textAbout?.length > 170
            ? setupService.textAbout.slice(0, 170) + "[...]"
            : setupService.textAbout
            }}
            <a [routerLink]="['/entity/home']">{{ "GENERAL.VIEW-MORE" | translate }} <nb-icon
                    icon="diagonal-arrow-right-up-outline"></nb-icon></a>
        </p>
        <hr class="divider" />
    </div>
</ng-template>

<!---------------------------------------
           FOOTER COPYRIGHT
----------------------------------------->
<ng-template #footerCopyright>
    <div class="footer-copyright">
        <div class="container h-100">
            <div class="row align-items-center h-100">
                <div class="col-auto">
                    <p>© 2002 - INFO ESPORTES LTDA - V.2024-05-17 19:35</p>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<!---------------------------------------
           FOOTER BACK TOP
----------------------------------------->
<ng-template #footerBackTop>
    <div class="footer-backtop">
        <div class="footer-backtop-block">
            <ng-container *ngTemplateOutlet="certificationTemplate"></ng-container>
        </div>
        <div class="footer-backtop-block">
            <button (click)="backToTop()">
                {{ "FOOTER.TOP" | translate }}
                <fa-icon [icon]="icons.caretUp"></fa-icon>
            </button>
        </div>
    </div>
</ng-template>
<!---------------------------------------
           CERTIFICATION
----------------------------------------->
<ng-template #certificationTemplate>
    <div class="selos">
        <ngb-carousel style="display: flex; align-items: center; justify-content: center"
            [showNavigationIndicators]="false" [showNavigationArrows]="false" [interval]="3000">
            <ng-container [ngTemplateOutlet]="certfDesktop"> </ng-container>
            <ng-template #certfDesktop>
                <ng-template ngbSlide *ngFor="let group of certificationsGroups">
                    <div class="row justify-content-center align-items-center">
                        <div class="col-auto" *ngFor="
                                let certf of certifications
                                    | slice
                                        : group * certificationsPerGroup
                                        : group * certificationsPerGroup + certificationsPerGroup;
                                let i = index
                            ">
                            <a *ngIf="certf.url_redirect" [href]="certf.url_redirect" target="_blank" rel="nofollow">
                                <img [src]="certf.url_banner" [alt]="certf.description"
                                    [style.height]="getImageHeight(i)" />
                            </a>
                            <img [src]="certf.url_banner" [alt]="certf.description" [style.height]="getImageHeight(i)"
                                *ngIf="!certf.url_redirect" />
                        </div>
                    </div>
                </ng-template>
            </ng-template>
            <!-- <ng-template #certfTablet>
                <ng-template ngbSlide>
                    <div class="row justify-content-center align-items-center">
                        <div class="col-auto" *ngFor="let certf of certifications | slice : 0 : 3; let i = index">
                            <img
                                [src]="certf.url_banner"
                                [alt]="certf.description"
                                [style.height]="getImageHeight(i)"
                            />
                        </div>
                    </div>
                </ng-template>
                <ng-template ngbSlide>
                    <div class="row justify-content-center align-items-center">
                        <div class="col-auto" *ngFor="let certf of certifications | slice : 3 : 6; let i = index">
                            <img
                                [src]="certf.url_banner"
                                [alt]="certf.description"
                                [style.height]="getImageHeight(i)"
                            />
                        </div>
                    </div>
                </ng-template>
            </ng-template>
            <ng-template #certfMobile>
                <ng-template ngbSlide *ngFor="let certf of certifications; let i = index">
                    <div class="row justify-content-center align-items-center">
                        <div class="col-auto">
                            <img
                                [src]="certf.url_banner"
                                [alt]="certf.description"
                                [style.height]="getImageHeight(i)"
                            />
                        </div>
                    </div>
                </ng-template>
            </ng-template> -->
        </ngb-carousel>
    </div>
</ng-template>